var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlannedTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05556 15H13.6944V13.375H6.05556V15Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6944 11.75H6.05556V10.125H13.6944V11.75Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05556 8.5H9.11111V6.875H6.05556V8.5Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29167 2C4.02601 2 3 3.09131 3 4.4375V15.8125C3 17.1587 4.02601 18.25 5.29167 18.25H14.4583C15.724 18.25 16.75 17.1587 16.75 15.8125V7.6875C16.75 4.54638 14.356 2 11.4028 2H5.29167ZM5.29167 3.625H10.6389V7.6875H15.2222V15.8125C15.2222 16.2612 14.8802 16.625 14.4583 16.625H5.29167C4.86978 16.625 4.52778 16.2612 4.52778 15.8125V4.4375C4.52778 3.98877 4.86978 3.625 5.29167 3.625ZM12.1667 3.70626C13.3975 3.97202 14.4135 4.86736 14.9044 6.0625H12.1667V3.70626Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedTimeIcon);
export default __webpack_public_path__ + "static/media/PlannedTimeIcon.28a52531a971ea1e5cca1bcc5c01842e.svg";
export { ForwardRef as ReactComponent };